import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { useTraining } from './data';
import Item from './Item';
import Chart from './Charts/Training';

const TrainingStatistic = () => {
  const { loading, training } = useTraining();

  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Training">
        {loading ? "Sedang memuat..." : (
          <Row>
            {training.map((item, key) => {
              return (
                <Col span={8} key={`training-stats-${key}`}>
                  <Item label={item.name} value={item.value}/>
                </Col>
              );
            })}
          </Row>
        )}
        <hr />
        <Chart loading={loading} training={training} />
      </Card>
    </Auxiliary>
  );
}

export default TrainingStatistic;